import { addDoc, collection, deleteDoc, doc, getDocs, getFirestore, query, serverTimestamp, Timestamp, where, writeBatch } from "firebase/firestore"


const deleteSale = async(sale_id:string, business_id:string, shop_id:string)=>{

    try {

        const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id,"sales", sale_id)
        
        await deleteDoc(ref)
        return
        
    } catch (error) {
        throw error
    }
    
}


const deleteSaleBulk = async(sales_ids:string[], business_id:string, shop_id:string)=>{
    
    try {
        
        const batch = writeBatch(getFirestore())
        
        sales_ids.forEach((sale_id)=>{
            
            const ref = doc(getFirestore(), "businesses", business_id, "shops", shop_id, "sales", sale_id)
            batch.delete(ref)
            
        })
        
        await batch.commit()
        return
        
    } catch (error) {
        throw error
    }
    
}

const getSales = async (user_id:string, shop_name:string)=>{


    try {

        const sales:any[] = []

        const queryRef = query(collection(getFirestore(), "businesses", user_id, "shops", shop_name, "sales"))
        const response = await getDocs(queryRef)

        response.forEach((sale)=>{
            sales.push({
                ...sale.data(),
                meta_data: {
                    ...sale.data()?.meta_data,
                    created_at: (new Timestamp(sale.data().meta_data.created_at.seconds, sale.data().meta_data.created_at.nanoseconds)).toMillis()
                },
                id: sale.id
            })
        })

        return sales
        
    } catch (error) {
        throw error
    }
    
}

const getSalesByDateRange = async(start_date:Date, end_date:Date, shop_name:string, user_id:string)=>{

    try {

        const sales:any[] = []

        const collectionRef = collection(getFirestore(), "businesses", user_id, "shops", shop_name, "sales")
        const queryRef = query(collectionRef, where("created_at", ">=", start_date), where("created_at", "<=", end_date))

        const res = await getDocs(queryRef)
        res.forEach((sale)=>{
            if(sale.exists()){
                sales.push({
                    ...sale.data(),
                    created_at: new Timestamp(sale.data().created_at.seconds, sale.data().created_at.nanoseconds).toDate()
                })
            }
        })

        return sales
        
    } catch (error) {
        throw error
    }
    
}

const recordSale = (cart_items:any[], shopkeeper:string,business_id:string, business_branch:string)=>{


    const sale = {
        total_items_sold: cart_items.reduce((prev, cur)=>prev + (cur["quantity"] || 0), 0),
        total_revenue: cart_items.reduce((prev, cur)=>prev + (cur["costPrice"] * cur["quantity"] || 0), 0),
        total_profit: cart_items.reduce((prev, cur)=>prev + ((cur["sellingPrice"] * cur["quantity"] - cur["costPrice"] * cur["quantity"]) || 0), 0),
        in_cart: cart_items
    }


    try {

        const ref = collection(getFirestore(), 'businesses', business_id, 'shops', business_branch, 'sales')
        addDoc(ref, {
            ...sale,
            meta_data: {
                shopkeeper,
                created_at: serverTimestamp()
            },
        })
        
    } catch (error) {
        throw error
    }
    
}



const Sale = {
    deleteSale,
    deleteSaleBulk,
    getSales,
    getSalesByDateRange,
    recordSale
}

export default Sale
